module.exports = __webpack_public_path__ + "img/logo-words.74ee18b4.svg";